import { render, staticRenderFns } from "./regTranferencia.vue?vue&type=template&id=34b941c7&"
import script from "./regTranferencia.vue?vue&type=script&lang=js&"
export * from "./regTranferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports